import DistParameter from './DistParameter';

export default DistParameter;